import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { TypographyFontSize, TypographyFontFamily } from '@design-system/components/atoms/typography/entities/typography.types';
import { CalendarDay, CalendarMonth } from '@design-system/components/molecules/calendar/entities/calendar.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { BackgroundSurfaceDsComponent } from '@design-system/components/atoms/background-surface/background-surface.component';

@Component({
  selector: 'app-ds-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    BackgroundSurfaceDsComponent,
  ]
})
export class CalendarDsComponent {

  @Input() month: CalendarMonth;

  @Output() clickEvent: EventEmitter<CalendarDay> = new EventEmitter<CalendarDay>();

  public readonly primarySize = TypographyFontSize.XS;
  public readonly weekDaySize = TypographyFontSize.XXXS;

  public readonly fontFamilyRegular = TypographyFontFamily.Regular;
  public readonly fontFamilySemiBold = TypographyFontFamily.SemiBold;

  constructor() { }

  public dayFontWeight(day: CalendarDay): string {
    return day.isToday ? TypographyFontFamily.SemiBold : TypographyFontFamily.Regular;
  }

  public clickEventTrigger(day: CalendarDay): void {
    if (day.visible && !day.disabled) {
      this.clickEvent.emit(day);
    }
  }

}
